import { render, staticRenderFns } from "./cModalTechnicalNurse.vue?vue&type=template&id=04ec2010&lang=es"
import script from "./cModalTechnicalNurse.vue?vue&type=script&lang=js"
export * from "./cModalTechnicalNurse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports